import { GiphyFetch } from '@giphy/js-fetch-api';
import { Grid } from '@giphy/react-components';
import debounce from 'lodash/debounce';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { IconSpinner, Modal } from '../../../../components';
import { manageDisableScrolling } from '../../../../ducks/ui.duck';
import { handleGifsUpload } from '../../../../util/circleHelper';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './CreatePostForm.module.css';
import poweredByGiphy from '../../../../assets/images/powerdByGiphy.png'
// const gf = new GiphyFetch('EV5W970Y4KjFSqKJaFDRpmkLQv3yD1KR');
const gf = new GiphyFetch(process.env.REACT_APP_GIPHY_API_KEY);
const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

const handleGifSelection = async (
  event,
  form,
  values,
  dispatch,
  onGiphyChange,
  formOldValues,
  setFormOldValues
) => {
  const response = await fetch(event?.images?.original_mp4.mp4);
  const blob = await response.blob();
  const file = new File([blob], 'giphy.gif', { type: 'image/gif' });
  const gifs = values?.gifs || [];
  const gifUrl = await handleGifsUpload(file, dispatch);
  if (formOldValues) {
    setFormOldValues({
      ...formOldValues,
      gifs: [...formOldValues?.gifs, gifUrl],
      giffiles: [
        ...formOldValues?.giffiles,
        {
          file: event?.images?.original?.url,
          signed_id: gifUrl?.signed_id,
        },
      ],
    });
  } else {
    form.change(`gifs`, [...gifs, gifUrl]);
    const fileArr = values?.giffiles || [];
    form.change(`giffiles`, [
      ...fileArr,
      {
        file: event?.images?.original?.url,
        signed_id: gifUrl?.signed_id,
      },
    ]);
  }
  onGiphyChange();
};
const gridWidth = isMobile ? '100%' : 650;
const columns = isMobile ? 2 : 4;
const gutter = isMobile ? 3 : 6;

const GifUploadModal = props => {
  const {
    isGiphyOpen,
    onGiphyChange,
    form,
    values,
    requestDirectUpload,
    formOldValues,
    setFormOldValues,
  } = props;
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState('horse');

   const debouncedSearch = useCallback(
      debounce((value) => {
        setSearchTerm(value || 'horse')
      }, 500),
      []
    );

  const handleGifSearch = (e) => {
    const value = e.target.value;
    debouncedSearch(value);
  }
  return (
    <div>
      <Modal
        id={'gifUploadModal'}
        isOpen={isGiphyOpen}
        onClose={() => !requestDirectUpload && onGiphyChange()}
        className={css.gifUploadModal}
        onManageDisableScrolling={manageDisableScrolling}
      >
        {requestDirectUpload ? (
          <div className={css.loader}>
            <IconSpinner type={true} />
          </div>
        ) : (
          <div className={css.gifWrapper}>
            <div className={css.heading}>
              <FormattedMessage id="Circle.gifModalTitle" />
            </div>
            <div>
              <div className={css.gifInput}>
                <input
                  type="text"
                  placeholder="Search GIPHY"
                  onChange={handleGifSearch}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              <div className={css.gifGridBox}>
                <Grid
                  key={searchTerm}
                  width={gridWidth}
                  columns={3} // Number of columns
                  fetchGifs={offset => gf.search(searchTerm, { offset, limit: 10 })}
                  gutter={gutter} // Space between GIFs
                  onGifClick={event =>
                    handleGifSelection(
                      event,
                      form,
                      values,
                      dispatch,
                      onGiphyChange,
                      formOldValues,
                      setFormOldValues
                    )
                  }
                  noLink={true}
                />
              </div>
              <div className={css.powerdByGiphy}>
                <img src={poweredByGiphy} />
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default GifUploadModal;
